import React from 'react';
import ConfigPopover from '../ConfigPopover';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';

const ChunkLoadingPopover: React.FC<any> = props => {
  return (
    <ConfigPopover width={266} onClose={props.close} withPaddings={false}>
      <LoadingIndicator />
    </ConfigPopover>
  );
};
ChunkLoadingPopover.displayName = 'ChunkLoadingPopover';

export default ChunkLoadingPopover;
